import { observer } from 'mobx-react-lite'
import classNames from 'classnames'
import { Typography } from 'shared/ui'
import { checkCDN } from 'shared/lib/checkCDN'
import { getAttachmentSizeReserve } from 'entities/Attachment'
import { MessageCardType, type MessageProps } from 'widgets/MessageCard/ui/types'
import { ConversationMessageCardItem } from 'widgets/MessageCard/ui/ConversationMessageCardItem/ConversationMessageCardItem'
import { DateContent } from 'widgets/MessageCard/ui/DateContent/DateContent'
import { usePresentationModeContext } from 'widgets/PresentationMode'
import styles from './styles.module.scss'

type IImagesContentProps = MessageProps & {
  reserveMediaSize?: boolean
}

export const ImagesContent = observer((props: IImagesContentProps) => {
  const { images } = props.message
  const presentationStore = usePresentationModeContext()
  const renderImages = images.length === 5 ? images.slice(0, 4) : images.slice(0, 6)
  const hiddenImages = images.length === 5 ? images.slice(4) : images.slice(6)
  const isSingleImage = renderImages.length === 1

  const gridStyle =
    props.reserveMediaSize && isSingleImage ? getAttachmentSizeReserve(renderImages[0]) : undefined

  const onOpenPresentation = (index: number) => () => {
    presentationStore.setAttachments(images, index, true)
  }

  if (!images.length) {
    return <></>
  }

  return (
    <ConversationMessageCardItem message={props.message} type={MessageCardType.Images}>
      <div
        className={classNames(
          styles.imagesWrap,
          styles[`with${images.length > 6 ? 'More' : images.length}`],
          {
            [styles.conversationsHistoryView]: props.message.isConversationsHistory,
          }
        )}
        style={gridStyle}
      >
        {renderImages.map((attachment, index) => {
          if (attachment.type === 'image' || attachment.type === 'gif') {
            return (
              <div
                className={classNames(styles.imgWrap, { [styles.imgWrapSquare]: !isSingleImage })}
                key={attachment.source}
                onClick={onOpenPresentation(index)}
              >
                <img
                  key={attachment.source}
                  {...(checkCDN(attachment.source) ? { crossOrigin: 'use-credentials' } : null)}
                  src={attachment.source}
                  alt=''
                  decoding={'sync'}
                  onLoad={props.onLoad}
                />
                {!!hiddenImages.length && index === renderImages.length - 1 && (
                  <div className={styles.hiddenImages}>
                    <Typography variant={'heading-sm'} ariaLabel={'hiddenImages'}>
                      +{hiddenImages.length}
                    </Typography>
                  </div>
                )}
              </div>
            )
          }
          return <div key={attachment.id}>No type</div>
        })}
      </div>
      <DateContent {...props} />
    </ConversationMessageCardItem>
  )
})
